import ApiService from '@/core/services/api.service'

// Actions types
export const GET_PERIODOSMOVIMIENTOS = 'getPeriodosMovimientos'
export const GET_PERIODOMOVIMIENTO = 'getPeriodoMovimiento'
export const CREATE_PERIODOMOVIMIENTO = 'createPeriodoMovimiento'
export const UPDATE_PERIODOMOVIMIENTO = 'updatePeriodoMovimiento'
export const DELETE_PERIODOMOVIMIENTO = 'deletePeriodoMovimiento'
export const DESACTIVAR_PERIODOMOVIMIENTO = 'desactivarPeriodoMovimiento'

//Mutadores
export const SET_PERIODOSMOVIMIENTOS = 'setPeriodoMovimiento'
export const SET_PERIODOMOVIMIENTO = 'setPeriodoMovimiento'
export const SET_ERROR = 'setError'

const state = {
    error: null,
    periodosMovimientos: []
}

const actions = {
    [GET_PERIODOSMOVIMIENTOS](context) {
        return new Promise((resolve) => {
            ApiService.setHeader();
            ApiService.get({ action: '/facturacioncomisionapi/api/PeriodoMovimiento/v1/PeriodoMovimiento' }, "")
                .then(({ data }) => {
                    context.commit(SET_PERIODOSMOVIMIENTOS, data);
                    resolve(data)
                })
                .catch(({ response }) => {
                    //console.log(("error: " + response);
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [GET_PERIODOMOVIMIENTO](context, periodoMovimiento) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.get({ action: `/facturacioncomisionapi/api/PeriodoMovimiento/v1/PeriodoMovimiento/${periodoMovimiento.codigoPeriodo}` }, periodoMovimiento)
                .then(({ data }) => {
                    context.commit(SET_PERIODOMOVIMIENTO, data)
                    resolve(data)
                })
                .catch(({ reponse }) => {
                    //console.log(("Hubo un error al obtener el Periodo Movimieneto. mensaje interno: " + response)
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [CREATE_PERIODOMOVIMIENTO](context, periodoMovimiento) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.post({ action: '/facturacioncomisionapi/api/PeriodoMovimiento/v1/PeriodoMovimiento/' }, periodoMovimiento)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, {
                        error: ["No se pudo ingresar el periodo movimiento"]
                    });
                    reject(response)
                });
        });
    },
    [UPDATE_PERIODOMOVIMIENTO](contexto, periodoMovimiento) {
        return new Promise((resolve, reject) => {
            ApiService.put({ action: `/facturacioncomisionapi/api/PeriodoMovimiento/v1/PeriodoMovimiento/` }, periodoMovimiento)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [DELETE_PERIODOMOVIMIENTO](context, periodoMovimiento) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.delete({ action: `/facturacioncomisionapi/api/PeriodoMovimiento/v1/PeriodoMovimiento/${periodoMovimiento.codigoPeriodo}` }, periodoMovimiento)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [DESACTIVAR_PERIODOMOVIMIENTO](context, periodoMovimiento){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/PeriodoMovimiento/v1/DesactivarPeriodoMovimiento'}, periodoMovimiento)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            })
        })
    }
}

const mutations = {
    [SET_ERROR](state, error){
        state.error = error
    },
    [SET_PERIODOSMOVIMIENTOS](state, periodosMovimientos){
        state.error = {}
        state.periodosMovimientos = periodosMovimientos
    }
}

export default {
    state,
    actions,
    mutations
}